import RecommendedArtworks from './RecommendedArtworks'

export default RecommendedArtworks
